import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property, state } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import '@shoelace-style/shoelace/dist/components/textarea/textarea.js';
import { emit } from '@amityeko/pbc-core/dist/utilities/event';
import '../typography/tg-label-two';
import styles from './styles';
/**
 * @dependency tg-label-two
 *
 *
 * @event {{ value }} amityeko-change - Emmited when textarea is changed.
 */
export default class AmityekoTextarea extends LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.value = '';
        this.placeholder = '';
        this.required = false;
        this.label = undefined;
        this.disabled = false;
        this.readonly = false;
        this.rows = 4;
        this.resize = 'none';
        this.hasCharacterCounter = false;
        this.hasAsterisk = false;
        this.currentCount = 0;
    }
    firstUpdated() {
        this.textarea = this.renderRoot.querySelector('#textarea');
    }
    _onChange(e) {
        this.value = e.target.value;
        emit(this, 'amityeko-change', { detail: { value: this.value } });
    }
    _onInputChange(e) {
        this.currentCount = e.target.value.length;
    }
    /** Resets the data in the element. */
    reset() {
        this.value = '';
    }
    render() {
        return html `
      <div class="textarea-container">
        <sl-textarea
          id="textarea"
          .name=${this.name}
          .value=${this.value}
          .placeholder=${this.placeholder}
          ?required=${this.required}
          minlength=${ifDefined(this.minlength)}
          maxlength=${ifDefined(this.maxlength)}
          ?disabled=${this.disabled}
          ?readonly=${this.readonly}
          rows=${this.rows}
          .resize=${this.resize}
          @sl-change=${this._onChange}
          @sl-input=${this._onInputChange}
        >
          ${this.label
            ? html `<amityeko-tg-label-two class="label" part="label" slot="label"
                >${this.label}
                ${this.required && this.hasAsterisk ? '*' : null}</amityeko-tg-label-two
              >`
            : null}
        </sl-textarea>
        ${this.hasCharacterCounter && this.maxlength
            ? html `<amityeko-character-counter
              class="count"
              .currentCount=${this.currentCount}
              .totalCount=${this.maxlength}
            ></amityeko-character-counter>`
            : null}
      </div>
    `;
    }
}
AmityekoTextarea.styles = styles;
__decorate([
    property({ attribute: false, reflect: true })
], AmityekoTextarea.prototype, "textarea", void 0);
__decorate([
    property()
], AmityekoTextarea.prototype, "name", void 0);
__decorate([
    property()
], AmityekoTextarea.prototype, "value", void 0);
__decorate([
    property()
], AmityekoTextarea.prototype, "placeholder", void 0);
__decorate([
    property({ type: Boolean })
], AmityekoTextarea.prototype, "required", void 0);
__decorate([
    property({ type: Number })
], AmityekoTextarea.prototype, "minlength", void 0);
__decorate([
    property({ type: Number })
], AmityekoTextarea.prototype, "maxlength", void 0);
__decorate([
    property()
], AmityekoTextarea.prototype, "label", void 0);
__decorate([
    property({ type: Boolean })
], AmityekoTextarea.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], AmityekoTextarea.prototype, "readonly", void 0);
__decorate([
    property({ type: Number })
], AmityekoTextarea.prototype, "rows", void 0);
__decorate([
    property()
], AmityekoTextarea.prototype, "resize", void 0);
__decorate([
    property({ type: Boolean })
], AmityekoTextarea.prototype, "hasCharacterCounter", void 0);
__decorate([
    property({ type: Boolean })
], AmityekoTextarea.prototype, "hasAsterisk", void 0);
__decorate([
    state()
], AmityekoTextarea.prototype, "currentCount", void 0);
if (!customElements.get('amityeko-textarea')) {
    customElements.define('amityeko-textarea', AmityekoTextarea);
}
//# sourceMappingURL=index.js.map